import { render, staticRenderFns } from "./work_notice.vue?vue&type=template&id=193caa02&scoped=true&"
import script from "./work_notice.vue?vue&type=script&lang=js&"
export * from "./work_notice.vue?vue&type=script&lang=js&"
import style0 from "./work_notice.vue?vue&type=style&index=0&id=193caa02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193caa02",
  null
  
)

export default component.exports